// extracted by mini-css-extract-plugin
export default {"badge":"IndicatorBadge_badge__ZXwFT"};